import React from "react";

const mapSrc =
  "https://www.google.com/maps?q=4Ter%20rue%20d'Orange,%2037400%20Amboise&output=embed";

const schedules = [
  { day: "Lundi", hours: "Fermé" },
  { day: "Mardi", hours: "Fermé" },
  { day: "Mercredi", hours: "11H00 - 13H00 / 14H00 - 19H00" },
  { day: "Jeudi - Vendredi", hours: "14h00 - 20h00" },
  { day: "Samedi", hours: "10h00 - 13H00 / 14H00 - 20h00" },
  { day: "Dimanche", hours: "11H00-13H00 / 14H00 - 18H00" },
];

function Contact() {
  return (
    <div className="w-full bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-8 lg:px-12 py-12 flex flex-col gap-10">
        <header className="text-center">

          <h1 className="text-xl md:text-xl font-bold text-orange-900 mt-2">
            Une question, une demande particulière, un petit mot ? Contactez-nous l 
          </h1>

        </header>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch">
          <div className="w-full h-72 md:h-80 lg:h-full min-h-[320px] overflow-hidden rounded-2xl shadow-lg bg-orange-50">
            <iframe
              title="Localisation MOOD"
              src={mapSrc}
              width="100%"
              height="100%"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="w-full h-full border-0"
            />
          </div>

          <div className="flex flex-col gap-6 bg-white border border-orange-100 rounded-2xl shadow-sm p-6 md:p-8">
            <div>
              <h2 className="text-xl font-bold text-slate-900">Adresse</h2>
              <p className="text-slate-700 mt-2 leading-relaxed">
                4Ter rue d&apos;Orange
                <br />
                37400 Amboise
              </p>
            </div>

            <div className="flex flex-col gap-2 text-slate-700">
              <p>
                <span className="font-semibold text-orange-600">Téléphone :</span>{" "}
                <a href="tel:0246468573" className="hover:text-orange-600">
                  02 46 46 85 73
                </a>
              </p>
              <p>
                <span className="font-semibold text-orange-600">Email :</span>{" "}
                <a href="mailto:contact@mood.com" className="hover:text-orange-600">
                  contact@mood-cafe-atelier.com
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="bg-orange-50 border border-orange-100 rounded-2xl p-6 md:p-8">
          <h2 className="text-xl font-bold text-slate-900 mb-4">Horaires</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-slate-700">
            {schedules.map((item) => (
              <div
                key={item.day}
                className="flex items-center justify-between bg-white rounded-xl px-4 py-3 shadow-sm"
              >
                <span className="font-semibold text-orange-600">{item.day}</span>
                <span>{item.hours}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
